import { render, staticRenderFns } from "./search-form-component.vue?vue&type=template&id=74a61a1c&lang=html&"
import script from "./search-form-component.vue?vue&type=script&lang=js&"
export * from "./search-form-component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports